import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "mx-auto w-3/4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Lu Key image",
  src: "/images/Lu_002.jpg",
  class: "mx-auto"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "h-12" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_6 = { class: "mx-auto w-3/4 text-left text-lg" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_8 = { class: "hasot text-left" }
const _hoisted_9 = { class: "mx-auto w-3/4 text-lg" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_11 = { class: "mx-auto w-3/4 text-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_13 = { class: "mx-auto w-3/4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_15 = { class: "mx-auto w-3/4 text-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_17 = { class: "mx-auto w-3/4 text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "h-14" }, null, -1)
const _hoisted_19 = { class: "mx-auto w-3/4 text-left" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "h-20" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeTop = _resolveComponent("HomeTop")!
  const _component_HomeTopJa = _resolveComponent("HomeTopJa")!
  const _component_HomeStory = _resolveComponent("HomeStory")!
  const _component_HomeStoryJa = _resolveComponent("HomeStoryJa")!
  const _component_HomeAboutLu = _resolveComponent("HomeAboutLu")!
  const _component_HomeAboutLuJa = _resolveComponent("HomeAboutLuJa")!
  const _component_HomeVideo = _resolveComponent("HomeVideo")!
  const _component_HomeVideoJa = _resolveComponent("HomeVideoJa")!
  const _component_HomeCollection = _resolveComponent("HomeCollection")!
  const _component_HomeCollectionJa = _resolveComponent("HomeCollectionJa")!
  const _component_HomeRoadmap = _resolveComponent("HomeRoadmap")!
  const _component_HomeRoadmapJa = _resolveComponent("HomeRoadmapJa")!
  const _component_HomeCopyright = _resolveComponent("HomeCopyright")!
  const _component_HomeCopyrightJa = _resolveComponent("HomeCopyrightJa")!
  const _component_HomeQuestion = _resolveComponent("HomeQuestion")!
  const _component_HomeQuestionJa = _resolveComponent("HomeQuestionJa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeTop, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeTopJa, { key: 1 }))
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeStory, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeStoryJa, { key: 1 }))
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_ctx.lang === 'en')
            ? (_openBlock(), _createBlock(_component_HomeAboutLu, { key: 0 }))
            : (_openBlock(), _createBlock(_component_HomeAboutLuJa, { key: 1 }))
        ])
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeVideo, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeVideoJa, { key: 1 }))
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeCollection, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeCollectionJa, { key: 1 }))
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeRoadmap, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeRoadmapJa, { key: 1 }))
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeCopyright, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeCopyrightJa, { key: 1 }))
      ]),
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        (_ctx.lang === 'en')
          ? (_openBlock(), _createBlock(_component_HomeQuestion, { key: 0 }))
          : (_openBlock(), _createBlock(_component_HomeQuestionJa, { key: 1 }))
      ])
    ]),
    _hoisted_20
  ], 64))
}